import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/authStore'

export function useUnreadCount() {
  const user = useAuthStore((s) => s.user)

  return useQuery({
    queryKey: ['unread-thread-count', user?.id],
    queryFn: async () => {
      if (!user?.id) return 0
      const { data, error } = await supabase.schema('delivery').rpc('get_unread_thread_count', {
        p_user_id: user.id,
      })
      if (error) throw error
      return data as number
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}
